import {FormControl, InputLabel, Select, Skeleton} from "@mui/material";
import {useTranslation} from "react-i18next";
import {FC} from "react";
import {RootState, useAppSelector} from "../../../store";
import MenuItem from "@mui/material/MenuItem";

interface Props {
    selectedCategory: string
    handleChangeCategory: (id: string) => void
    isAdminPanel?: boolean
    disableCategoriesWithoutWishes?: boolean
}

const CategorySelect: FC<Props> = (props) => {
    const {t, i18n} = useTranslation()
    const categories = useAppSelector((state: RootState) => state.categoryReducer.items)
    const categoriesLoading = useAppSelector((state: RootState) => state.categoryReducer.fetchCategoriesLoading)

    return (
        !categoriesLoading && categories.length ? <FormControl fullWidth size="small">
            <InputLabel id="wish_categories">{t('category')}</InputLabel>
            <Select
                labelId="wish_categories"
                id="wish_categories"
                color="primary"
                value={props.selectedCategory}
                label={t('category')}
                onChange={(e) =>
                    props.handleChangeCategory(e.target.value)}
            >
                {categories.map((category) => (
                    <MenuItem value={category.id}
                              disabled={props.disableCategoriesWithoutWishes ? category.count === 0 : false}
                              key={category.id}>{category[`name_${i18n.language}`]}{!props.isAdminPanel ? ` (${(category.count !== 0 || category.id === 'all') ? category.count : t('coming_soon')})` : ''}</MenuItem>
                ))}
            </Select>
        </FormControl> : <Skeleton animation='wave' variant='rectangular' height={50} width="100%"/>
    )
}

export default CategorySelect
